import { getUnregisteredUserConfig } from '@/config/unregisteredUser.config';
import UnregisteredPopup from '@/shared-components/popups/unregistered-user-popup';

import './auction-unregistered-popup.css';

export default function AuctionUnregisteredPopup(props) {
  const cfg = getUnregisteredUserConfig();
  const auctionImagePool = [
    cfg?.auction_guest_image,
    cfg?.auction_guest_image_2,
    cfg?.auction_guest_image_3,
  ].filter(Boolean);

  const customVariants = auctionImagePool.length
    ? auctionImagePool.map((imageId) => ({
      title: cfg?.title || 'Welcome to Suarte',
      image: imageId,
    }))
    : null;

  return (
    <UnregisteredPopup
      {...props}
      containerClassName="container-unregistered--auction"
      containerType="auction-unregistered"
      customVariants={customVariants || undefined}
    />
  );
}
